import _ from 'lodash'

import JSONWrapper from './json-wrapper'
import TileSetSchema from '../../../public/json/tileset.schema.json'

/**
 * Обертка над тайлсетом
 *
 * @extends {JSONWrapper}
 */
class TileSet extends JSONWrapper {
  /**
   * Конструктор объекта с тайлсетом из записи с ресурсом.
   * Информация о файле будет в свойстве `file`
   *
   * @param {Object} resource Запись с ресурсом
   * @param {Object} resource.description JSON тайлсета. Становится корнем
   */
  constructor(resource) {
    const tileset = resource.description
    const file = _.omit(resource, ['description'])
    super(tileset, ['file'])
    this.setSchemas(TileSetSchema)
    this.file = file
    this.isLoaded = false
    this.image = new Image()
    this.image.onload = () => {
      this.isLoaded = true
      if (this.onload) {
        this.onload()
      }
    }
    this.image.src = `/api/files/${file.file.physicalName}`
  }

  hasItem(name) {
    return Boolean(this.frames[name])
  }

  item(tile) {
    return this.frames[tile.textureName]
  }

  get names() {
    return Array.from(Object.keys(this.frames))
  }

  /**
   * Вернуть запись с ресурсом в исходном виде.
   * Может использоваться при отправке тайлсета на сервер
   *
   */
  get resource() {
    const resource = {
      ...this.file,
      description: this.object
    }
    if (resource.new) {
      delete resource.new
      delete resource.id
    }
    return resource
  }
}

export default TileSet
